import { type WithTranslation, withTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import Avatar from '@/components/Avatar';
import { type AvatarInfo } from '@/types';
import CustomLink from '../CustomLink';
import styles from './styles';

type Props = {
  user?: AvatarInfo;
} & WithTranslation;

const ProfileAvatar = ({ t, user }: Props) => (
  <IconButton
    title={t('PROFILE')}
    component={CustomLink}
    to="/me"
    sx={styles.button}
  >
    <Avatar user={user} />
  </IconButton>
);

export default withTranslation()(ProfileAvatar);
